<template>
  <div class="main">
    <div class="back" @click="backBtn">
      <i></i>
      <span>返回</span>
    </div>
    <h2>基本信息</h2>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="培训名称：" prop="name">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>
      <el-form-item label="开始时间：" prop="startTime">
        <el-date-picker
          v-model="ruleForm.startTime"
          type="date"
          placeholder="选择日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="培训时长：" prop="duration">
        <div class="duration">
          <el-input v-model.number="ruleForm.duration"></el-input>
          <el-select v-model="value1" placeholder="请选择">
            <el-option
              v-for="item in timeUnit"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </el-form-item>
      <el-form-item label="培训备注：" prop="notes">
        <el-input
          type="textarea"
          placeholder="请输入培训备注"
          v-model="ruleForm.notes"
        >
        </el-input>
      </el-form-item>
    </el-form>
    <div class="foot">
      <el-button type="primary" @click="submitForm('ruleForm')"
        >下一步</el-button
      >
    </div>
  </div>
</template>

<script>
import training from "@/api/trainingApi";
export default {
  data() {
    return {
      ruleForm: {
        name: "",
        startTime: "",
        duration: "",
        notes: "",
      },
      value1: "day",
      timeUnit: [
        {
          label: "天",
          value: "day",
        },
        {
          label: "周",
          value: "week",
        },
        {
          label: "月",
          value: "moon",
        },
      ],
      // pickerOptions: {
      //   disabledDate(time) {
      //     return time.getTime() < Date.now() - 86400000; // 这里也可以根据需要调整禁用条件，例如减去一天的毫秒数以禁用今天及之前的日期
      //   },
      // },
      rules: {
        name: [{ required: true, message: "请输入培训名称", trigger: "blur" }],
        startTime: [
          {
            required: true,
            message: "请选择培训开始时间",
            trigger: "change",
          },
        ],
        duration: [
          { required: true, message: "请输入培训时长", trigger: "blur" },
        ],
      },
    };
  },
  props: ["cutcoms"],
  methods: {
    // 返回按键
    backBtn() {
      this.$destroy();
      this.cutcoms(0);
    },
    async init() {
      if (this.$parent.operateState == 0) {
        // 新增
        this.ruleForm = {
          name: "",
          startTime: "",
          duration: "",
          notes: "",
        };
      } else if (this.$parent.operateState == 1) {
        // 编辑
        const obj = {
          trainId: this.$parent.examRow.tranid,
        };
        const { data } = await training.getTrainByID(obj);
        if (data.Status == 200) {
          this.ruleForm.name = data.Data.trainInfo.Name;
          this.ruleForm.startTime = data.Data.trainInfo.begainTime;
          this.ruleForm.duration = data.Data.trainInfo.days;
          this.ruleForm.notes = data.Data.trainInfo.Remark;
          this.$parent.list_vip = data.Data.studentArr.map((item) => {
            for (let ztiem in item) {
              if (item[ztiem] === "" || item[ztiem] === null) {
                item[ztiem] = "未设置";
              }
            }
            item.UserID = item.StudentID;
            item.Birthday1 = this.$moment(item.Birthday).format(
              "YYYY/MM/DD HH:mm"
            );
            return item;
          });
          console.log(this.$parent.list_vip);
        } else {
          this.$message.error(data.Data);
        }
        console.log(data, "??");
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$parent.addInfo = this.ruleForm;
          if (this.value1 == "week") {
            this.ruleForm.duration = this.ruleForm.duration * 7;
          } else if (this.value1 == "moon") {
            this.ruleForm.duration = this.ruleForm.duration * 30;
          }
          this.cutcoms(2);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
  activated() {
   this.$nextTick(()=>{
    this.init();
   })
  },
};
</script>

<style lang="scss" scoped>
 ::v-deep .el-form {
    width: 400px;
    padding: 24px;
    .duration {
      display: flex !important;
      > .el-input {
        flex: 1.5;
        margin-right: 30px;
      }
      > .el-select {
        flex: 1;
      }
    }
  }
  ::v-deep .el-textarea__inner {
    height: 160px !important;
  }
.main {
  box-sizing: border-box;
  background-color: #ffffff;
  width: 100%;
  min-height: 780px;
  h2 {
    padding: 24px;
    margin-bottom: 48px;
  }
 
  .foot {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 8%;
    margin-bottom: 24px;
    > .el-button {
      width: 128px;
    }
  }
}
// 返回按键css
.back {
  border-bottom: 1px solid #f8f8f8;
  padding: 10px 0px 9px 24px;
  background-color: #fff;
  height: 44px;
  border-radius: 0px 0px 10px 10px;
  i {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-top: 2px solid #999999;
    border-left: 2px solid #999999;
    transform: scaleY(0.6) rotate(-45deg);
  }
  span {
    cursor: pointer;
    width: 47px;
    height: 25px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}
</style>